import SaveButton from 'CMFW/button/SaveButton';
import ModuleContext from 'CMFW/context/ModuleContext';
import Translations from 'components/translation/Translations';
import { IRefIds } from 'constants/refs';
import HanziModel from 'models/HanziModel';
import React, { useContext } from 'react';
import styled from 'styled-components';
import { CardItem, MissingItem } from './types';

/**
 * Names of a GF component for the learner, per source dialect: translations of ref 112
 * (global, item = GF number), edited with the shared Translations editor like any other
 * translatable text and saved with the Save button.
 */
const HanziComponentNames: React.FC = () => {
  const model = useContext(ModuleContext) as HanziModel;
  const item = model.itemUpdated as CardItem | MissingItem | undefined;
  if (!item || !item.sources) {
    return null;
  }

  return (
    <Wrapper>
      <Header>
        <Title>Learner name · GF {HanziModel.gfSeqOf(item)}</Title>
        <SaveButton />
      </Header>
      <Translations keyName={'sources'} refId={IRefIds.hanziComponentName} memory={false} search={false} />
    </Wrapper>
  );
};

export default HanziComponentNames;

const Wrapper = styled.div`
  margin-bottom: 16px;
  padding-bottom: 8px;
  border-bottom: 1px solid #e3e8ef;
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
`;

const Title = styled.div`
  font-weight: 500;
`;
